
import React, { useState, useEffect } from 'react';
import logo from '../../../assets/images/LogoLaramie.png';

import './index.css';
import Tip from "../../common/Tip";

function Footer(props) {
    const [version, setVersion] = useState(null);

    useEffect(() => {
        fetch('/laramie-version.json', { cache: 'no-store' })
            .then((res) => (res.ok ? res.json() : null))
            .then((data) => data && data.version && setVersion(data.version))
            .catch(() => {});
    }, []);

    return (
        <footer className="footer">
            <div className="container-fluid-footer p-left-50">
                <img src={logo} alt="logo" height={16}/>
                <div className="footer-icons p-right-50">
                    {version &&
                    <span className="m-right-5">Versión {version}</span>
                    }
                    {props.tipName &&
                    <Tip name={props.tipName} position="top" />
                    }
                </div>
            </div>
        </footer>
    )
}

export default Footer;